/**
 * External Dependencies
 */
import 'jquery';
import './polyfills';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import marquee from './alpine/marquee';
import feedCarousel from './alpine/feedCarousel';
import statsCarousel from './alpine/statsCarousel';
import quoteSpotlightSlider from './alpine/quoteSpotlightSlider';
import featuredCards from './alpine/featuredCards';
import navSlider from './alpine/navSlider';
import accordion from './alpine/accordion';
import newQuotes from './alpine/newQuotes';
import responsiveSlider from './alpine/responsiveSlider';
import registerModalStore from './alpine/modal';
import singlePostArticle from './alpine/single-post-article';
import HeroVideo from './hero-video';
// import Modal from './modal';
import Accordion from './accordion';
import siteHeader from './alpine/siteHeader';
import LazyLoad from 'vanilla-lazyload/dist/lazyload';
import autoplayVideo from './alpine/autoplayVideo';
import heroBanner from './alpine/heroBanner';
import productCards from './alpine/productCards';
import tabbedFeatures from './alpine/tabbedFeatures';



let lazyLoadInstance = null;

window.Alpine = Alpine;
Alpine.data('marquee', marquee);
Alpine.data('feedCarousel', feedCarousel);
Alpine.data('statsCarousel', statsCarousel);
Alpine.data('quoteSpotlightSlider', quoteSpotlightSlider);
Alpine.data('featuredCards', featuredCards);
Alpine.data('newQuotes', newQuotes);
Alpine.data('accordion', accordion);
Alpine.data('responsiveSlider', responsiveSlider);
Alpine.data('navSlider', navSlider);
Alpine.data('autoplayVideo', autoplayVideo);
Alpine.data('heroBanner', heroBanner);
Alpine.data('productCards', productCards);
Alpine.data('tabbedFeatures', tabbedFeatures);
Alpine.data('siteHeader', siteHeader);
Alpine.data('singlePostArticle', singlePostArticle);

registerModalStore(Alpine);
Alpine.plugin(collapse);
Alpine.start();

$(document).ready(() => {
  // SiteHeader.init();
  // Modal.init();
  Accordion.init();
  HeroVideo.init();

  lazyLoadInstance = new LazyLoad({
    elements_selector: '[data-echocrate-do-lazy-load]',
    use_native: false,
    class_loaded: 'lazy-loaded',
    callback_loaded: function (el) {
      const closest = el.closest('.lazy-load-wrapper');
      if (closest) {
        closest.classList.add('lazy-loaded-wrapper');
      }
    },
  });
});

document.addEventListener('facetwp-loaded', function () {
  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }
});